<!--US Page-->
<div class="dtfpaymentoptions">
   <!--Announcement Banner Code-->
   <div class="dtf-alertpage"></div>


   <!--Banner-->
   <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_PaymentOptions_Header.jpg);">
      <section class="mbfs-home-hero__header">
         <h2 class="mbfs-home-hero__header-subtitle">
            {{ 'PaymentOptions.Title' | translate }}
         </h2>
         <p class="mbfs-home-hero__header-text">
            {{ 'PaymentOptions.Subtitle' | translate }}
          </p>
      </section>
      
   </section>
   <!-- <section class="mbfs-repay-banner-inner">
      <div class="mbfs-home-hero__header-subtitle2">
         {{ 'PaymentOptions.Subtitle' | translate }}
      </div>  
   </section> -->

   <div class="page-container">
   <div><span class="bold-text">{{ 'PaymentOptions.RegisteredCustomers1' | translate }}</span></div>
   <div>{{ 'PaymentOptions.RegisteredCustomers2' | translate }}
      <span><a class="hyperlinktext" href="https://daimler-truckfinancial.com/home" >{{
            'PaymentOptions.RegisteredCustomers3' | translate }}</a></span>
      <span>{{ 'PaymentOptions.RegisteredCustomers4' | translate }}</span>      
   </div>
  
   <div class="numbered-item">{{ 'PaymentOptions.AutoPayNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.AutoPayTitle' | translate }}</span><span class="standard-text">{{
      'PaymentOptions.AutoPayText' | translate }}</span></div>

   <div class="numbered-item">{{ 'PaymentOptions.OnlinePayNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.OnlinePayTitle' | translate
      }}</span><span class="standard-text">{{ 'PaymentOptions.OnlinePayText' | translate }}</span></div>

   <br>
   <div class="bold-text">{{ 'PaymentOptions.AllCustomers' | translate }}</div>

   <div class="numbered-item">{{ 'PaymentOptions.PhonePayNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.PhonePayTitle' | translate
         }}</span>{{ 'PaymentOptions.PhonePayText' | translate }}</div>

   <div class="numbered-item">{{ 'PaymentOptions.GuestPayNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.GuestPayTitle' | translate
         }}</span>{{ 'PaymentOptions.GuestPayText1' | translate }}<a class="hyperlinktext" href="https://dtf.repay.io/ebpp/" target="_blank">{{ 'PaymentOptions.GuestPayText2' | translate }}</a>{{ 'PaymentOptions.GuestPayText3' | translate }}</div>
      

   <p class="numbered-item">{{ 'PaymentOptions.MailPayNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.MailPayTitle' | translate }}</span>{{ 'PaymentOptions.MailPayText' | translate }}</p>


   <ul>
      <div class="staticflex">
         <div>
            <div class="column-text">
               <li><div class="bold-text">{{ 'PaymentOptions.NonFleetMailingAddressHeader' | translate }}</div></li>          
               <li><div>{{ 'PaymentOptions.MailingCompany' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.NonFleetPOBox' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.MailingCityStateZip' | translate }}</div></li>
               <br>
            </div>
         </div>

         <div style="margin-left: 5.7%;">
            <div class="column-text">
               <li><div class="bold-text">{{ 'PaymentOptions.FleetMailingAddressHeader' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.MailingCompany' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.FleetPOBox' | translate }}</div>
               <li><div>{{ 'PaymentOptions.MailingCityStateZip' | translate }}</div></li>
               
            </div>
         </div>
      </div>
   </ul>
   <p class="numbered-item">{{ 'PaymentOptions.OvernightNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.OvernightTitle' | translate }}</span></p>
   <ul>
      <div class="staticflex">
         <div>
            <div class="column-text">
               <li><div class="bold-text">{{ 'PaymentOptions.OvernightNonFleetAddressHeader' | translate }}</div>
               <li><div>{{ 'PaymentOptions.MailingCompany' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OverNightNonFleetPOBox' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OvernightStreetAddress' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OvernightCityStateZip' | translate }}</div></li>
               <br>
            </div>
         </div>

         <div>
            <div class="column-text">
               <li><div class="bold-text">{{ 'PaymentOptions.OvernightFleetAddressHeader' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.MailingCompany' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OverNightFleetPOBox' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OvernightStreetAddress' | translate }}</div></li>
               <li><div>{{ 'PaymentOptions.OvernightCityStateZip' | translate }}</div></li>
            </div>
         </div>
      </div>
   </ul>
   <p class="numbered-item">{{ 'PaymentOptions.WesternUnionNumber' | translate }}<span class="bold-text">{{ 'PaymentOptions.WesternUnionTitle' | translate
         }}</span></p>
         
   <ul>
      <div class="staticflex">
         <div>
            <div class="column-text">
               <div>{{ 'PaymentOptions.WesternUnionAddress1' | translate }}</div>
               <div>{{ 'PaymentOptions.WesternUnionAddress2' | translate }}</div>
               <div>{{ 'PaymentOptions.WesternUnionAddress3' | translate }}</div>
            </div>
         </div>

         <div>
            <div class="column-text">
               <!--empty column here-->
               <!-- <div>{{ 'PaymentOptions.EmptyString' | translate }}</div> -->
            </div>
         </div>
      </div>
   </ul>
   </div>
  